import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@chakra-ui/react";
import { ArrowNarrowRight } from "~/icons";

export const RsvpCta: FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Button
        fontWeight="bold"
        size="th-slim"
        type="submit"
        variant="th-primary"
        w="fit-content"
      >
        {t("rsvp.register.cta")}
        <ArrowNarrowRight h={4} w={4} ml="6px" mt="1px" strokeWidth="3" />
      </Button>
    </Box>
  );
};
